
const digest = '8386089b43058566c2036d68213254d67eef950ae71a1d3d73e455f684a59d0c';
const classes = {"wrapper":"_wrapper_1p90d_1"};
const css = `._wrapper_1p90d_1 {
  flex-basis: 33.33%;
  padding: 4px;
  text-align: center;
  font-family: "Roboto", sans-serif;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  